const header = document.querySelector('header.header');
const filterContainer = document.querySelector('.filter-toolbar');

const currentScrollCoordinates = () => {
  if (document.body.classList.contains('scroll-up')) {
    // Header is visible
    filterContainer.style.setProperty('--offset', `${header.offsetHeight}px`);
  } else {
    // Header is not visible
    filterContainer.style.setProperty('--offset', '0px');
  }
};

document.addEventListener('scroll', () => {
  currentScrollCoordinates();
});
